import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { EcomalCredentialsInputDTORuntype, EcomalResponseBodyDTORuntype } from './ecomalBackendTypes';

export const ecomalEndpoints = {
    'GET /3rdparty/ecomal/credentials': endpoint({
        description: 'Returns credentials for Ecomal integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: EcomalResponseBodyDTORuntype,
    }),
    'POST /3rdparty/ecomal/credentials': endpoint({
        description: 'Uploads credentials for Ecomal API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: EcomalCredentialsInputDTORuntype,
        responseBody: EcomalResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/ecomal/credentials'],
    }),
    'PATCH /3rdparty/ecomal/credentials': endpoint({
        description: 'Updates credentials for Ecomal API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: EcomalCredentialsInputDTORuntype,
        responseBody: EcomalResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/ecomal/credentials'],
    }),
    'DELETE /3rdparty/ecomal/credentials': endpoint({
        description: 'Deletes existing credentials for Ecomal API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/ecomal/credentials'],
    }),
};
